module.exports = __webpack_public_path__ + "static/img/00index1_16.ee1b153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/00index1_16.jpg
// module id = TJeY
// module chunks = 0